import { Search, SparklesIcon } from 'lucide-react';
import { useState } from 'react';
import { t } from '@/lib/i18n';
import { MOD_LABEL } from '@/lib/hooks';
import { openSearch } from '@/shell/searchStore';
import { Button, Input, Kbd } from '@/ui';
import s from './Assistant.module.css';

/** AI is optional (RULES §AI-2): explain, and offer search instead. */
export function AiOffState() {
  const [q, setQ] = useState('');
  return (
    <div className={s.empty}>
      <span className={s.emptyIcon}>
        <SparklesIcon aria-hidden />
      </span>
      <p className={s.emptyTitle}>{t('The assistant is not configured')}</p>
      <p className={s.emptyText}>
        {t(
          'No AI provider is set up for your company, so the assistant cannot answer questions. Everything else works as usual — and search finds any vehicle, driver, device or page.',
        )}
      </p>
      <form
        className={s.offSearch}
        onSubmit={(e) => {
          e.preventDefault();
          openSearch(q);
        }}
      >
        <Input icon={Search} value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('Search instead…')} aria-label={t('Search')} />
        <Button type="submit" variant="primary">
          {t('Search')}
        </Button>
      </form>
      <p className={s.emptyHint}>
        {t('Tip: press')} <Kbd>{MOD_LABEL}</Kbd> <Kbd>K</Kbd> {t('to search from anywhere.')}
      </p>
    </div>
  );
}
